import React from "react";

import { Code } from "@packages/ds";
import { useIntl } from "react-intl";

import * as Accordion from "ds/Accordion";
import { capitalize } from "Libs/utils";
import { useCurrentWorker } from "Reducers/environment/hooks/useCurrentWorker";
import Link from "src/tickets/common/components/Link";

import * as S from "./styles";

import type { WithWorkers, WithoutWorkers } from "./types";

type Props = {
  currentApp: {
    appName: string;
    withWorkers: WithWorkers[];
    withoutWorkers?: WithoutWorkers[];
  };
  command: string;
  isWorker?: boolean;
};

const CommandsSection = ({ currentApp, command, isWorker = false }: Props) => {
  const intl = useIntl();
  const formatMessage = useIntl().formatMessage;
  const currentWorker = useCurrentWorker();

  const message = formatMessage({ id: "CLI_command_name" });

  if (isWorker) {
    const worker = currentApp.withWorkers.find(
      w => w.workerName === currentWorker?.displayName
    );
    const workerCommand = worker?.instances?.[0]?.[command];

    return (
      <>
        {command === "cliCommand" ? (
          <S.MessageContainer>
            <S.Message>
              {intl.formatMessage({
                id: "access_your_worker_container"
              })}
            </S.Message>
            <Link href={formatMessage({ id: "links.CLI_repository" })}>
              {`${capitalize(message)} CLI`}
            </Link>
          </S.MessageContainer>
        ) : (
          <S.MessageContainer>
            <S.Message>
              {intl.formatMessage({
                id: "access_your_worker_container"
              })}
            </S.Message>
            <S.Message>
              {intl.formatMessage({
                id: "basic_ssh"
              })}
            </S.Message>
          </S.MessageContainer>
        )}
        <Code.Block singleLine isCopyable id="cli_cmd">
          {workerCommand}
        </Code.Block>
      </>
    );
  }

  return (
    <Accordion.Root type="multiple" defaultValue={["item-00"]}>
      <>
        {command === "cliCommand" ? (
          <S.MessageContainer>
            <S.Message>
              {intl.formatMessage({
                id: "access_your_application_container"
              })}
            </S.Message>
            <Link
              href={formatMessage({ id: "links.CLI_repository" })}
              target="_blank"
              rel="noopener noreferrer"
            >
              {`${capitalize(message)} CLI`}
            </Link>
          </S.MessageContainer>
        ) : (
          <S.MessageContainer>
            <S.Message>
              {intl.formatMessage({
                id: "access_your_application_container"
              })}
            </S.Message>
            <S.Message>
              {intl.formatMessage({
                id: "basic_ssh"
              })}
            </S.Message>
          </S.MessageContainer>
        )}
        <Code.Block singleLine isCopyable id="cli_cmd">
          {currentApp.withoutWorkers?.[0][command]}
        </Code.Block>
      </>
    </Accordion.Root>
  );
};
export default CommandsSection;
